import React from 'react';
import {
  Box,
  Typography,
  FormControl,
  Select,
  InputLabel,
  Checkbox,
  OutlinedInput,
  MenuItem as MuiMenuItem,
  ListItemText,
} from '@mui/material';

export function Section({ title, children }) {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        {title}
      </Typography>
      {children}
    </Box>
  );
}

export function MultiSelectField({ label, options, value, onChange, disabled }) {
  return (
    <FormControl fullWidth sx={{ mb: 2 }}>
      <InputLabel>{label}</InputLabel>
      <Select
        multiple
        value={value}
        onChange={onChange}
        input={<OutlinedInput label={label} />}
        renderValue={(selected) => selected.join(', ')}
        disabled={disabled}
        sx={{
          '& .Mui-disabled': {
            '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.38)',
          },
          '& .MuiSelect-icon.Mui-disabled': {
            color: 'rgba(0, 0, 0, 0.38)',
          },
        }}
      >
        {options.map((option) => (
          <MuiMenuItem key={option} value={option}>
            <Checkbox checked={value.indexOf(option) > -1} disabled={disabled} />
            <ListItemText
              primary={option}
              sx={{
                '& .MuiTypography-root': {
                  color: disabled ? 'rgba(0, 0, 0, 0.38)' : 'inherit',
                },
              }}
            />
          </MuiMenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
